module.exports = __webpack_public_path__ + "static/media/faisalabad.5ae22e03.svg";